import { IColaboradorWorkflow } from '../../models/workflow.colaborador.model';
import { IWorkflowAcao } from '../../models/workflow.acao.model';

export class WorkflowDefaultModalService {
    static $inject = [
        '$uibModal'
    ];

    constructor(
        private $uibModal: ng.ui.bootstrap.IModalService,
    ) { }

    public open(acao: IWorkflowAcao, trabalhador: IColaboradorWorkflow): angular.ui.bootstrap.IModalInstanceService {
        return this.$uibModal.open({
            template: require('html-loader!./workflow.default.html'),
            controller: 'WorkflowDefaultModalController',
            controllerAs: 'confirm',
            backdrop: 'static',
            resolve: {
                acao: () => acao,
                trabalhador: () => trabalhador
            }
        });
    }
}
